export default [
    {
        path: '/purchase/resource',
        name: 'PurchaseResource',
        component: () => import('@/pages/purchase/resource/Resource.vue'),
        meta: {
            title: '资源使用',
            requireAuth: true,
            authority: 'purchase:resource'
        },
        redirect: '/purchase/resource/flow',
        children: [
            {
                path: 'flow',
                name: 'PurchaseResourceFlow',
                component: () => import('@/pages/purchase/resource/flow/Flow.vue'),
                meta: {
                    title: '流量与存储',
                    requireAuth: true,
                    authority: 'purchase:resource'
                }
            },
            {
                path: 'record',
                name: 'PurchaseResourceRecord',
                component: () => import('@/pages/purchase/resource/record/Record.vue'),
                meta: {
                    title: '购买记录',
                    requireAuth: true,
                    authority: 'purchase:resource'
                }
            },
        ]
    },
    {
        path: '/purchase/versions',
        name: 'PurchaseVersions',
        component: () => import('@/pages/purchase/versions/Versions.vue'),
        meta: {
            title: '版本订购',
            requireAuth: true,
            authority: 'purchase:versions'
        },
        redirect: '/purchase/versions/buy',
        children: [
            {
                path: 'buy',
                name: 'PurchaseVersionsBuy',
                component: () => import('@/pages/purchase/versions/buy/Buy.vue'),
                meta: {
                    title: '版本服务',
                    requireAuth: true,
                    authority: 'purchase:versions'
                }
            },
            {
                path: 'record',
                name: 'PurchaseVersionsRecord',
                component: () => import('@/pages/purchase/versions/record/Record.vue'),
                meta: {
                    title: '购买记录',
                    requireAuth: true,
                    authority: 'purchase:versions'
                }
            },
        ]
    },
    // 版本订购 - 支付页面
    {
        path: '/purchase/versions/payment',
        name: 'PurchaseVersionsPayment',
        component: () => import('@/pages/purchase/versions/buy/Payment.vue'),
        meta: {
            title: '订单支付',
            requireAuth: true,
            authority: 'purchase:versions'
        }
    },
    {
        path: '/purchase/versions/unpaid',
        name: 'PurchaseVersionsPayment',
        component: () => import('@/pages/purchase/versions/buy/Payment.vue'),
        meta: {
            title: '订单待付',
            requireAuth: true,
            authority: 'purchase:versions'
        }
    },
    {
        path: '/purchase/versions/payResult',
        name: 'PurchaseVersionsResult',
        component: () => import('@/pages/purchase/versions/buy/Result.vue'),
        meta: {
            title: '支付结果',
            requireAuth: true,
            authority: 'purchase:versions'
        }
    },
    {
        path: '/purchase/versions/unpaidResult',
        name: 'PurchaseVersionsResult',
        component: () => import('@/pages/purchase/versions/buy/Result.vue'),
        meta: {
            title: '待付结果',
            requireAuth: true,
            authority: 'purchase:versions'
        }
    },
    // 资源使用 - 支付页面
    {
        path: '/purchase/resource/payment',
        name: 'PurchaseResourcePayment',
        component: () => import('@/pages/purchase/resource/flow/Payment.vue'),
        meta: {
            title: '订单支付',
            requireAuth: true,
            authority: 'purchase:resource'
        }
    },
    {
        path: '/purchase/resource/unpaid',
        name: 'PurchaseResourcePayment',
        component: () => import('@/pages/purchase/resource/flow/Payment.vue'),
        meta: {
            title: '订单待付',
            requireAuth: true,
            authority: 'purchase:resource'
        }
    },
    {
        path: '/purchase/resource/payResult',
        name: 'PurchaseResourceResult',
        component: () => import('@/pages/purchase/resource/flow/Result.vue'),
        meta: {
            title: '支付结果',
            requireAuth: true,
            authority: 'purchase:resource'
        }
    },
    {
        path: '/purchase/resource/unpaidResult',
        name: 'PurchaseResourceResult',
        component: () => import('@/pages/purchase/resource/flow/Result.vue'),
        meta: {
            title: '待付结果',
            requireAuth: true,
            authority: 'purchase:resource'
        }
    }
]


// WEBPACK FOOTER //
// ./src/router/module/purchase.js